import React from 'react';
import C18Input00 from './C18Input00'
import C18InputError00 from './C18InputError00'
import C18Button00 from './C18Button00'
import C18Anchor00 from './C18Anchor00'
import history from "../../history"
import {addToAdminLog, loadDevicesInfo, updateDeviceInfo, rnRest, handleRnMsg, loadZonesInfo, loadGatewaysInfo, loadPrivsInfo, privs} from './C18utils';
import {dbVals} from '../../components/utils/http';
import{wsTrans, saveTokens,getUId,checkLoggedIn,getWindowResize} from '../utils/utils';
import {cl, globs, constant, initInfos, getTime,ufs,getLocalStorage,saveLocalStorage} from '../../components/utils/utils';

class C18Login00 extends React.Component{
  constructor(props) {
    super(props);
    document.title="Login";
//     cl(props)
//     cl(dbVals)
    this.doMobileLogin()

    this.state={
      email: "",//"LabSite2@grr.la",
      password: "",
      passwordVisible:false,
      passwordType: "password",
      rememberMe: false,
      loggedIn:false,
      loading:false,
      mfa:null,// C20C22-4541 MFA: {mfaId, email, loginEmail, expiresAt, resendAt, sends, maxSends, device} while the code screen shows
      mfaCode:"",
      mfaMsg:"",
      mfaMsgType:"",
      mfaBusy:false,
      mfaNow:Date.now(),
      mfaDone:false,// right code, redirecting: everything is disabled
      mfaLock:null,// {email, until} after too many wrong codes: Log In is disabled for that email
    }
     this.alerts=[
      "Please Enter a Valid Email",//6
      "Checking . . .",//12
      "Please Enter Your Email Address"
     ];
     this.loadInfo()
  }
  
  testUfs=async()=>{
    let files=await ufs.list()
    cl(files)
  }
  
  loadInfo=async()=>{
//     cl("load info")
    await checkLoggedIn()
    let url="/usa/c18/sites"
    if(globs.userData?.loggedIn) {
      if(globs.requestedUrl){url=globs.requestedUrl}
      cl("pushing url")
//       history.push(url)
    } else {
      let ret=this.setState({loggedIn:globs?.userData?.loggedIn})
//       cl(ret)
    }
//     this.testUfs()

//     cl(globs.userData.loggedIn)
    
  }
  
  doLogin=async(force=false)=>{
//     globs.userData=null
//     cl(globs.requestedUrl)
    initInfos()
    let deviceId = getUId()// if the uId hasn't been loaded

//     cl("login");
//     cl(dbVals)
//     dbVals=dbVals||null
//     globs=globs||null
//     cl("login")
    this.setState({loading:true})
    wsTrans("usa", {cmd: "cRest", uri: "/o/users/login", method: "create", 
      body: {
        email: this.state.email,
        password: this.state.password,
        uId:deviceId,
        rememberMe: this.state.rememberMe,
        ...this.mfaClientInfo(),// C20C22-4541 MFA: browser + time zone, shown in the code email
        force: force,// if logged in elsewhere
      }}).then(async r=>{
//       if(r.result=="notFound"){
//         this.mySetState("login",{passwordError:"I can't find that email / password combination"})
//       }
      switch(r.result){
        case "notFound":
          this.mySetState("login",{passwordError:"I can't find that email / password combination"})
          this.setState({loading:false})
          break
        case "notActive":
          this.mySetState("login",{passwordError:"This user is not Active"})
          this.setState({loading:false})
          break
        case "mfaRequired":// C20C22-4541 MFA: password is right, now ask for the email code
          this.startMfa(r.data, null, this.state.email)
          break
        case "mfaLocked":// C20C22-4541 MFA: too many wrong codes (or code emails), wait
          this.setMfaLock(this.state.email, r.data?.retryIn, r.data?.reason)
          break
        case "ok":
        case "alreadyLoggedIn":
          await this.finishLogin(r)
          break
//         case "alreadyLoggedIn":
//           this.setState({alreadyLoggedInMessage:"You're already logged into this account somewhere else"})
//           break
        default:
          this.setState({loading:false})
          this.mySetState("login",{generalError:"Cannot connect. Please try again later"})
          break
      }
//       if(r.result=="ok"){
//         switch(globs.userData.mode){
//           case "c18":
//             history.push("")
//             break
//           default:
//             break
//         }
// //         history.push('/usa/dash/vz4sci_m-iHC9nQZ');
//       }

    })
    .catch((err)=> {
      this.setState({loading:false})
      this.mySetState("login",{generalError:"Cannot connect. Please try again later"})
    })
  }

  finishLogin=async(r)=>{
/* the end of a good login (moved here unchanged from doLogin "ok",
so the MFA code check can use the same steps - C20C22-4541) */
    // admin log with user info
    globs.sitesInfo.got=false
    globs.zonesInfo.got=false
    globs.usersInfo.got=false
    getWindowResize()
//           cl(r.session)
    saveTokens(r.data.accessToken, r.data.refreshToken, r.session)
    await loadDevicesInfo()
    await loadZonesInfo()
    await loadGatewaysInfo()
    await loadPrivsInfo()
//           cl("tokens saved")
    setTimeout(async()=>{
//             console.log("login to sites")
      let adds = [{
        userId:globs.userData?.session?.userId,
        time:Math.floor(getTime()),
        action:"login",
        deviceName: globs.device?.deviceName,
        oldVal:"",
        newVal:"",
      }]
      addToAdminLog(adds)
      let url="/usa/c18/sites"
      if(globs.zonesInfo.info.length == 1) {
        let z = globs.zonesInfo.info[0]
        // check if current user has permission to view zone
        await wsTrans("usa", {cmd: "cRest", uri: "/s/sessions", method: "update", 
          sessionId: globs.userData.session.sessionId,
          body: {siteId:z.siteId}})
        globs.userData.session.siteId=z.siteId
        if(privs("zone",z.zoneId,constant.AREA_PRIVS_READ)){
          url=`/usa/c18/sites/${z.siteId}/zones/${z.zoneId}`
        }
      }
      if(globs.requestedUrl){url=globs.requestedUrl}
      history.push(url)
      this.setState({loading:false})
//             cl(`Pushed: ${url}`)
//             history.push("/usa/c18/sites")
      // window.location="/usa/c18/sites" 
    },1000)

    // send msg to device to save remember me and whether bio login should be enabled
    if (window.ReactNativeWebView) {
      let device
      if (this.state.bioEnabled == 0) {
         // send credentials and tell device to ask user if they want biometric login to be enabled
         device = await rnRest("/authenticate", "update", {email: this.state.email, password: this.state.password})
         // update device
         await updateDeviceInfo(device)
      }
      // save remember me to device
      device = await rnRest("/device", "update", {rememberMe: this.state.rememberMe})
      await updateDeviceInfo(device)
    } 
//           switch(globs.userData.mode){
//             case "c18":
//               history.push("/usa/c18/sites")
//               break
//             default:
// //               let dash=await getHomeDashboard()
// //               if(dash){history.push(`/usa/dash/${dash}`)}
//               break
//           }
// // //           userSpecificHome()
  }

  doMobileLogin=async(force=false)=>{
//     cl("doMobileLogin")
    var body
    if (window.ReactNativeWebView) {
      initInfos()
      let deviceId = getUId()
      let ret = await rnRest("/authenticate", "retrieve", {deviceId: deviceId})
      // set device id as uid if possible
      if (ret.device.deviceId) {
        deviceId = getUId(ret.device.deviceId)
      }
      this.setState({bioEnabled: ret.device.bioEnabled, rememberMe: ret.device.rememberMe || this.state.rememberMe})
      
      // check if email and password exist, bioLogin is enabled
      // do auto login
      if (ret.credentials?.email && ret.credentials?.password && ret.device.bioEnabled == 2) {
        this.setState({loading: true})
        wsTrans("usa", {cmd: "cRest", uri: "/o/users/login", method: "create", 
        body: {
          email: ret.credentials.email,
          password: ret.credentials.password,
          uId: deviceId,
          rememberMe: ret.device.rememberMe || this.state.rememberMe,
          ...this.mfaClientInfo(),// C20C22-4541 MFA
          force: force,// if logged in elsewhere
        }}).then(async r=>{
          cl(r);
          switch(r.result){
            case "notFound":
              this.mySetState("login",{passwordError:"I can't find that email / password combination"})
              this.setState({loading:false})
              break
            case "notActive":
              this.mySetState("login",{passwordError:"This user is not Active"})
              this.setState({loading:false})
              break
            case "mfaRequired":// C20C22-4541 MFA: show the code screen
              this.setState({loading:false})
              this.startMfa(r.data, ret.device, ret.credentials.email)
              break
            case "mfaLocked":// C20C22-4541 MFA
              this.setMfaLock(ret.credentials.email, r.data?.retryIn, r.data?.reason)
              break
            case "ok":
              globs.sitesInfo.got=false
              globs.zonesInfo.got=false
              globs.usersInfo.got=false
              saveTokens(r.data.accessToken, r.data.refreshToken, r.session)
              // create device (if not already made)
              await loadDevicesInfo()
              await loadZonesInfo()
              await loadGatewaysInfo()
              await loadPrivsInfo()
              // update device on table with info
              await updateDeviceInfo(ret.device)
              setTimeout(async()=>{ 
                // push history to c18host so nav state changes
                let adds = [{
                  userId:globs.userData.session.userId,
                  time:Math.floor(getTime()),
                  action:"login",
                  deviceName: globs.device?.deviceName,
                  oldVal:"",
                  newVal:"",
                }]
                addToAdminLog(adds)
                let url = "/usa/c18/sites"
                if(globs.zonesInfo.info.length == 1) {
                  let z = globs.zonesInfo.info[0]
                  await wsTrans("usa", {cmd: "cRest", uri: "/s/sessions", method: "update", 
                    sessionId: globs.userData.session.sessionId,
                    body: {siteId:z.siteId}})
                  globs.userData.session.siteId=z.siteId
                  if(privs("zone",z.zoneId,constant.AREA_PRIVS_READ)){
                    url=`/usa/c18/sites/${z.siteId}/zones/${z.zoneId}`
                  }
                }
                history.push(url)
                this.setState({loading:false})
                // window.location="/usa/c18/sites"
              },1000)
              break
          case "alreadyLoggedIn":
            // this.setState({alreadyLoggedInMessage:"You're already logged into this account somewhere else"})
            this.setState({loading:false})
            break
          default:
            this.setState({loading:false})
            break
          }
        })
        .catch((err)=> {
          this.mySetState("login",{generalError:"Cannot connect. Please try again later"})
          this.setState({loading:false})
        })
      } 
      // get uid
      // let uid = await rnRest("/device", "retrieve", "")
      // if (!uid) {
      //   getUId()// if the uId is not available on device
      //   // send uId and base device info
      // }

      const handleMessage = async (e) => {
        // new version to accomodate rest transaction
        // window.ReactNativeWebView.postMessage(JSON.stringify(e.data))
        // handleRnMsg(e.data)
        return
        // make sure checking device
        if (e.data) {          
          let data = JSON.parse(e.data)
//           let body
          switch (data.cmd) {
            case ("fetch device id"):
              // fetch it
              // send another msg back to device
            case ("putDeviceInfo"):
                await loadDevicesInfo()
                // only take fields that are device-specific
                body = {
                  deviceName: data?.deviceName || globs.device.deviceName,
                  deviceToken: data?.deviceToken,
                  deviceInfo: data?.deviceInfo,
                  bioEnabled: data?.bioEnabled,
                  deviceTheme: data?.deviceTheme || globs.device.deviceTheme,
                }
                cl(body)
                await updateDeviceInfo(body)

                globs.devicesInfo={}
                await loadDevicesInfo()
                cl(globs.device)
                break
            case ("putDeviceId"):
              // load device uId
              getUId(data.uId)
              break
            case ("doLogin"):
              // check if info needs to be updated
              cl("mobile login")
              body = {
                  email: data.email,
                  password: data.password,
                  rememberMe: this.state.rememberMe,
                  force: force,// if logged in elsewhere
              }
              cl(body)
              // check if email and password exist, bioLogin is enabled
              if (body.email && body.password && data.bioEnabled == 2) {
                // do auto login
                wsTrans("usa", {cmd: "cRest", uri: "/o/users/login", method: "create", 
                body: body}).then(async r=>{
                  cl(r);
                  switch(r.result){
                    case "ok":
                    globs.sitesInfo.got=false
                    globs.zonesInfo.got=false
                    globs.usersInfo.got=false
                    saveTokens(r.data.accessToken, r.data.refreshToken, r.session)
                    await loadDevicesInfo()
                    setTimeout(()=>{ 
                      // push history to c18host so nav state changes
                      let adds = [{
                        userId:globs.userData.session.userId,
                        time:Math.floor(getTime()),
                        action:"login",
                        deviceName: globs.device?.deviceName,
                        oldVal:"",
                        newVal:"",
                      }]
                      addToAdminLog(adds)
                      history.push("/usa/c18/sites")
                      // window.location="/usa/c18/sites"
                    },1000)

                    // request info from device
                    data = {cmd: "getDeviceInfo"}
                    window.ReactNativeWebView.postMessage(JSON.stringify(data))
                    break
                  case "alreadyLoggedIn":
                    // this.setState({alreadyLoggedInMessage:"You're already logged into this account somewhere else"})
                    break
                  default:
                    break
                  }
                })
              }
              break
            }
          }
        }
      // window.addEventListener("message", async (e) => handleMessage(e))
      // document.addEventListener("message", async (e) => handleMessage(e))
      // request device id
      // let data = {cmd: "getDeviceId"}
      // window.ReactNativeWebView.postMessage(JSON.stringify(data))
      // request device info
      // let data = {cmd: "getLoginInfo"}
      // window.ReactNativeWebView.postMessage(JSON.stringify(data))
    }
  }
  
  validEmail=(email)=>{
    let atPos = email.indexOf("@");
    let perPos = email.lastIndexOf(".");
//     cl(atPos,perPos)
    return ((atPos > 0) && (perPos > atPos));
  }

  validate=(state, forgotPassword=false)=>{
    if(!this.validEmail(state.email)) {
      return (forgotPassword) ? this.setAlert(2) : this.setAlert(0);
    }
    return this.setAlert(1);
  }
  
  setAlert=(n)=>{
    let state=this.state
    var emailError
    switch(n){
      case 0:
        emailError=this.alerts[n]
        break
      case 2:
        emailError=this.alerts[n]
        break
    }
    this.setState({
      emailError: emailError,
    });
  }
  
  mySetState=(type,vals)=>{
    var state={}
    Object.assign(state,this.state,vals)
    this.validate(state)
    this.setState(vals)
  }
  
  forgotPassword=async()=>{
    cl("send forgot")
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/forgot", method: "create", 
      body: {email:this.state.email}})
    // C20C22-4579: backend no longer returns the reset token, link is only in the email
    cl(res)
  }
  
  onChange=(type,vals)=>{
//     cl([type,vals])
    switch(type){
      case "input":
        vals.passwordError=""
        vals.generalError=""
        this.mySetState("input",vals)
        break
      case "visibility":
        let type=(this.state.passwordType=="text")?"password":"text"
        this.setState({passwordVisible: !this.state.passwordVisible})
        break
      case "forgotPassword":
        vals.e.preventDefault()
        this.validate(this.state, true)
        if(this.state.email && !this.state.emailError){
          let msg="If you have an account, we've sent you a message."
          this.forgotPassword()
          this.mySetState("forgot",{emailError:msg})
        }
        break
      case "keyPress":
        if(
          (vals.key=="Enter")&&
          (this.validEmail(this.state.email))&&
          (!this.state.loggedIn)&&
          (!this.isMfaLocked())// C20C22-4541 MFA
        ){
          this.doLogin(false)
        }
        break
      default:
        break
    }
  }
  
  /****************** MFA - email sign-in code (C20C22-4541) *********************/
  componentWillUnmount(){
    this.stopMfaTimer()
    if(this.mfaLockTimer){clearTimeout(this.mfaLockTimer)}
  }

  startMfaTimer=()=>{
    this.stopMfaTimer()
    this.mfaTimer=setInterval(()=>{this.setState({mfaNow:Date.now()})},1000)
  }

  stopMfaTimer=()=>{
    if(this.mfaTimer){clearInterval(this.mfaTimer); this.mfaTimer=null}
  }

  /* too many wrong codes: Log In stays disabled for that email until the lock ends (the server checks it too) */
  setMfaLock=(email, retryIn, reason)=>{
    let secs=retryIn||300
    let mins=Math.ceil(secs/60)
    let why=(reason=="tooManyCodes")?"Too many sign-in codes were sent.":"Too many wrong codes."
    if(this.mfaLockTimer){clearTimeout(this.mfaLockTimer)}
    this.mfaLockTimer=setTimeout(()=>{this.setState({mfaLock:null})}, secs*1000)
    this.leaveMfa()
    this.setState({mfaLock:{email:(email||"").trim().toLowerCase(), until:Date.now()+secs*1000,
      msg:`${why} Please try again in ${mins} ${(mins==1)?"minute":"minutes"}.`}})
  }

  mfaClientInfo=()=>{// browser + time zone for the code email ("Requested: ...")
    let tz=""
    try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone||""}catch(e){}
    return {browser: navigator?.userAgent||"", tz: tz}
  }

  isMfaLocked=()=>{
    let lk=this.state.mfaLock
    return !!(lk && lk.until > Date.now() && lk.email==(this.state.email||"").trim().toLowerCase())
  }

  startMfa=(data, device, loginEmail)=>{// data from login: {mfaId, email, expiresIn, resendIn}
    let now=Date.now()
    this.setState({
      loading:false,
      mfa:{
        mfaId: data?.mfaId,
        loginEmail: loginEmail || this.state.email,// key for the trust token
        email: data?.email || this.state.email,
        expiresAt: now+(data?.expiresIn||300)*1000,
        resendAt: now+(data?.resendIn||30)*1000,
        sends: data?.sends||1,
        triesLeft: data?.triesLeft??3,// wrong codes left for this user, all browsers together (from the server)
        maxSends: data?.maxSends||3,
        codesLeft: data?.codesLeft??((data?.maxSends||3)-(data?.sends||1)),// from the server: counts all logins of this user
        device: device,// mobile app only
      },
      mfaCode:"", mfaMsg:"", mfaMsgType:"", mfaBusy:false, mfaNow:now, mfaDone:false,
    })
    this.startMfaTimer()
  }

  leaveMfa=(passwordError="")=>{// back to the email / password screen
    this.stopMfaTimer()
    this.setState({mfa:null, mfaCode:"", mfaMsg:"", mfaMsgType:"", mfaBusy:false, mfaDone:false,
      password:"", passwordError:passwordError, loading:false})
  }

  mfaSecsLeft=(t)=>{
    return Math.max(0, Math.ceil((t-this.state.mfaNow)/1000))
  }

  mfaTimeStr=(secs)=>{
    return `${Math.floor(secs/60)}:${("0"+(secs%60)).slice(-2)}`
  }

  onMfaCode=(val)=>{
    let code=(val||"").replace(/\D/g,"").slice(0,6)// digits only
    this.setState({mfaCode:code})
    if(code.length==6){this.verifyMfa(code)}// submit without pressing Enter
  }

  verifyMfa=async(code)=>{
    let mfa=this.state.mfa
    if(!mfa || this.state.mfaBusy){return}
    this.setState({mfaBusy:true, mfaMsg:"", mfaMsgType:""})
    try{
      let r=await wsTrans("usa", {cmd: "cRest", uri: "/o/users/mfa", method: "update",
        body: {mfaId: mfa.mfaId, code: code}})
      switch(r?.result){
        case "ok":
          this.stopMfaTimer()
          this.setState({mfaMsg:"Code accepted. Signing you in...", mfaMsgType:"ok", loading:true, mfaDone:true})
          await this.finishLogin(r)
          if(mfa.device){await updateDeviceInfo(mfa.device)}// mobile app, same as the Face/Touch ID login
          break
        case "mfaWrongCode":
          let left=r.data?.triesLeft
          this.setState({mfaBusy:false, mfaCode:"", mfa:Object.assign({}, mfa, {triesLeft: left}),
            mfaMsg:`That code is not right. ${left} ${(left==1)?"try":"tries"} left.`, mfaMsgType:"error"})
          break
        case "mfaTooManyTries":
          this.setMfaLock(mfa.loginEmail, r.data?.retryIn)
          break
        case "mfaExpired":
          if(this.mfaSecsLeft(mfa.expiresAt)>0 || mfa.codesLeft<=0){// login attempt gone, or no more codes to send
            this.leaveMfa("Your sign in code expired. Please log in again.")
          }else{
            this.setState({mfaBusy:false, mfaCode:"",
              mfaMsg:"That code has expired. Send a new code.", mfaMsgType:"error"})
          }
          break
        case "notActive":
          this.leaveMfa("This user is not Active")
          break
        default:
          this.setState({mfaBusy:false, mfaMsg:"Cannot connect. Please try again later", mfaMsgType:"error"})
          break
      }
    }catch(e){
      cl(e)
      this.setState({mfaBusy:false, mfaMsg:"Cannot connect. Please try again later", mfaMsgType:"error"})
    }
  }

  resendMfa=async()=>{
    let mfa=this.state.mfa
    if(!mfa || this.state.mfaBusy || this.mfaSecsLeft(mfa.resendAt)>0){return}
    this.setState({mfaBusy:true, mfaMsg:"", mfaMsgType:""})
    try{
      let r=await wsTrans("usa", {cmd: "cRest", uri: "/o/users/mfa", method: "create",
        body: {mfaId: mfa.mfaId}})
      let now=Date.now()
      switch(r?.result){
        case "ok":
          this.setState({mfaBusy:false, mfaCode:"", mfaMsg:"We've sent you a new code.", mfaMsgType:"ok",
            mfa:Object.assign({}, mfa, {expiresAt: now+(r.data?.expiresIn||300)*1000,
              resendAt: now+(r.data?.resendIn||30)*1000, sends: r.data?.sends||(mfa.sends+1),
              triesLeft: r.data?.triesLeft??mfa.triesLeft,
              codesLeft: r.data?.codesLeft??Math.max(0, mfa.codesLeft-1)})})
          break
        case "mfaMaxSends":// no more codes, the last one still works
          this.setState({mfaBusy:false, mfa:Object.assign({}, mfa, {sends: mfa.maxSends, codesLeft: 0})})
          break
        case "mfaWait":
          this.setState({mfaBusy:false,
            mfa:Object.assign({}, mfa, {resendAt: now+(r.data?.resendIn||30)*1000})})
          break
        case "mfaTooManyTries":
          this.leaveMfa("Too many codes sent. Please log in again.")
          break
        case "mfaExpired":
          this.leaveMfa("Your sign in code expired. Please log in again.")
          break
        default:
          this.setState({mfaBusy:false, mfaMsg:"Cannot connect. Please try again later", mfaMsgType:"error"})
          break
      }
    }catch(e){
      cl(e)
      this.setState({mfaBusy:false, mfaMsg:"Cannot connect. Please try again later", mfaMsgType:"error"})
    }
  }

  renderMfa=()=>{
    let mfa=this.state.mfa
    let resendSecs=this.mfaSecsLeft(mfa.resendAt)
    let signedIn=this.state.mfaDone// redirecting: disable everything
    let codesLeft=Math.max(0, mfa.codesLeft||0)
    let noMoreCodes=(codesLeft<=0)
    // built by hand: some browser locales show midnight as "0:53 AM" (C20C22-4541 QA)
    let exp=new Date(mfa.expiresAt)
    let expiresAt=`${(exp.getHours()%12)||12}:${("0"+exp.getMinutes()).slice(-2)} ${(exp.getHours()<12)?"AM":"PM"}`
    let msgStyle=(this.state.mfaMsgType=="ok")?
      {background:"#dff3e6", color:"#1e6b3a"}:
      {background:"#f8dcd9", color:"#a2392e"}
    return(
      <form onSubmit={e=>e.preventDefault()}>
        <h1>Enter your sign-in code</h1>
        <p style={{fontSize:13, marginBottom:"0.8em"}}>
          We sent a 6-digit code to <b>{mfa.email}</b>. It can take a minute to arrive.
          Not in your inbox? Look in Junk.
        </p>
        {this.state.mfaMsg&&
          <div style={Object.assign({padding:"8px 10px", borderRadius:4, fontSize:13,
            fontWeight:500, marginBottom:"0.8em"}, msgStyle)}>
            {this.state.mfaMsg}
          </div>
        }
        <input type="text" id="mfa-code"
          inputMode="numeric" autoComplete="one-time-code" maxLength={6} autoFocus
          value={this.state.mfaCode}
          disabled={this.state.mfaBusy || signedIn}
          onChange={e=>this.onMfaCode(e.currentTarget.value)}
          style={{textAlign:"center", fontSize:24, letterSpacing:"0.5em", fontWeight:600,
            height:44, marginBottom:"0.5em"}}
        />
        <div style={{textAlign:"center", fontSize:13}}>
          <span>It expires at <b>{expiresAt}</b>. </span>
          <span>{(codesLeft>0) ?
            `You can request ${codesLeft} more ${(codesLeft==1)?"code":"codes"}.` :
            "You can't request more codes."}</span>
          {/* C20C22-4541 QA: tries are counted per user on the server, so a new window shows what is left */}
          {/* <div><b>{mfa.triesLeft}</b> wrong {(mfa.triesLeft==1)?"try":"tries"} left.</div> */}
        </div>
        <div className="button-container">
          <C18Button00 type="button" className="outlined" style={{width:240}}
            onClick={()=>this.resendMfa()}
            disabled={noMoreCodes || resendSecs>0 || this.state.mfaBusy || signedIn}>
            {noMoreCodes ? "No more codes" :
              (resendSecs>0)?`Send a new code in ${this.mfaTimeStr(resendSecs)}`:"Send a new code"}
          </C18Button00>
        </div>
        <div style={{textAlign:"center"}}>
          {signedIn ?
            <span style={{color:"#999"}}>Use a different account</span> :
            <C18Anchor00 to="" onClick={e=>{e.preventDefault(); this.leaveMfa()}}>
              Use a different account
            </C18Anchor00>
          }
        </div>
      </form>
    )
  }
  /****************** End MFA *********************/

  render(){
//     cl(dbVals)
//     cl(this.state.loggedIn)
    let msg=(this.state.loggedIn)?"You're still logged in on another tab":this.state.emailError
//     cl(this.state.tokenLink)
    return(
    <div>
      <div className="login-register-new">
        <div className="login-left">
        </div>
        <div id="/login" className="login-right">

        <header>
          <div className="main-logo floatleft">
            <a href="https://link4controls.com/" className="main-logo"><img src="/img/link4_logo_blue_trans.png" alt="Link4 Controls" translate="no"/></a>
          </div>
          {!this.state.mfa &&// C20C22-4541 MFA: hidden on the code screen, it would drop the login in progress
          <div className="floatright">
            Don't have an account? <C18Anchor00 id="back-to-login" to="/usa/c18/register">Register</C18Anchor00>
          </div>
          }
        </header>

          {this.state.mfa ? this.renderMfa() :
          <form>
            <h1>Welcome Back</h1>
            {/* C20C22-4541 MFA: new feature note */}
            <div style={{display:"flex", alignItems:"center", gap:10, padding:"10px 12px", margin:"0 0 1em",
              background:"#e8f1fb", border:"1px solid #b9d3f0", borderRadius:6, color:"#1a4f8b", fontSize:14, fontWeight:500}}>
              {/* <span className="material-icons-outlined" style={{fontSize:28, color:"#B22222"}}>celebration</span> */}
              {/* <span style={{fontSize:26}}>&#127881;</span> */}
              <span className="material-icons-outlined" style={{fontSize:28, color:"#1a4f8b"}}>verified_user</span>
              <span>New: Protect your account with an email sign-in code. Turn it on in User Profile.</span>
            </div>

            <C18InputError00 parms={{
              type:'email',
              title:"Email",
              id:"if-email",
              required: true,
              value: this.state.email,
              valueId: "email",
              onChange: this.onChange,
              onKeyPress:e=>this.onChange("keyPress",{key:e.key}),
              message:msg,
              messageType: "error",
              disabled:this.state.loggedIn,
            }}/>
            <C18InputError00 parms={{
              type:'password',
              visible:this.state.passwordVisible,
              title:"Password",
              id:"if-password",
              required: true,
              value: this.state.password,
              valueId: "password",
              onChange: this.onChange,
              onKeyPress:e=>this.onChange("keyPress",{key:e.key}),
              message:this.isMfaLocked() ? this.state.mfaLock.msg : this.state.passwordError,// C20C22-4541 MFA lock
              messages:this.state.generalError,
              messageType: "error",
              disabled:this.state.loggedIn,
            }}/>

            <div className="remember-container">
              {/* C20C22-4541 MFA: "Remember this device for 30 days" removed (QA/lead feedback) */}
              <div id="forgot-password" className="floatright"><C18Anchor00 to=""
              onClick={e=>this.onChange("forgotPassword",{e:e})}
                disabled={this.validEmail(this.state.email)}
              >Forgot Password?</C18Anchor00></div>
            </div>
            <div className="clearfloat"></div>

            <div className="button-container">
              {window.ReactNativeWebView && this.state.bioEnabled == 2 &&
              <C18Button00 type="button" id="login-button" className="filled"
                onClick={async()=>await this.doMobileLogin()}
              >Face/Touch ID Login</C18Button00>
              }
              <C18Button00 type="button" id="login-button" className="filled"
                onClick={()=>this.doLogin(false)}
                disabled={!this.validEmail(this.state.email) || this.state.loggedIn || this.state.loading || this.isMfaLocked()}>
                 {this.state.loading ? 
                  <span>
                    <span className="spinnerGraph">
                      <img style={{height:15,width:15}} src="/img/spinner.gif" />
                    </span>
                    <span>Logging In...</span>
                  </span> : 
                  <span>Log In</span>}
              </C18Button00>
            </div>

          </form>}
          <div id="footer" className="login">
            <p>Cloud-Based Environmental Controls</p>
            <p>Copyright &copy;2021&nbsp;<span translate="no">Link4 Corporation</span>. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </div>
    )
  }
}

export default C18Login00;
